export function extractSseEvents(input, carry = '', options = {}) {
  const flush = Boolean(options.flush);
  const combined = `${carry}${input || ''}`;
  const normalized = flush && combined && !combined.endsWith('\n') ? `${combined}\n` : combined;
  const lines = normalized.split('\n');
  const nextCarry = flush ? '' : lines.pop() || '';
  const events = [];

  for (const rawLine of lines) {
    const line = rawLine.endsWith('\r') ? rawLine.slice(0, -1) : rawLine;
    if (!line.startsWith('data: ')) continue;
    const data = line.slice(6).trim();
    if (data === '[DONE]') {
      events.push({ type: '__done__' });
      continue;
    }
    events.push(JSON.parse(data));
  }

  return { events, carry: nextCarry };
}
